import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    studentsList: [],
    loading: false,
    error: null,
    response: null,
    statestatus: "idle",
};

const studentSlice = createSlice({
    name: 'student',
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
            state.error = null;
            state.response = null;
            state.statestatus = "idle";
        },
        stuffDone: (state, action) => {
            state.loading = false;
            state.error = null;
            state.response = action.payload;
            state.statestatus = "added";
        },
        getSuccess: (state, action) => {
            state.studentsList = action.payload;;
            state.loading = false;
            state.error = null;
            state.response = null;
            state.statestatus = "idle";
        },
        getFailed: (state, action) => {
            state.loading = false;
            state.error = action.payload || "Unknown error occurred";
            state.response = state.error;
        },
        getError: (state, action) => {
            state.loading = false;
            state.error = action.payload;

        },
        underStudentControl: (state) => {
            state.loading = false;
            state.response = null;
            state.error = null;
            state.statestatus = "idle";
        },
    },
});

export const {
    getRequest,
    getSuccess,
    getFailed,
    getError,
    underStudentControl,
    stuffDone,
} = studentSlice.actions;

export const studentReducer = studentSlice.reducer;
